import React, { useCallback, useState } from 'react';
import { Box } from '@apia/theme';
import { arrayOrArray } from '../../../../../utils/util';
import IconButton from '../../../buttons/IconButton';
import {
  TResponsiveTableRow,
  TResponsiveTableCellRenderer,
  TResponsiveTableCellRendererProps,
} from '../types';

export default function makeAccordionAsyncRenderer(
  additionalInfoGetter: (row: TResponsiveTableRow) => Promise<
    {
      label?: string;
      name: string;
    }[]
  >,
) {
  const InnerRender: TResponsiveTableCellRenderer = React.forwardRef<
    HTMLElement,
    TResponsiveTableCellRendererProps
  >(({ row }, ref) => {
    const [moreInfo, setMoreInfo] = useState<
      | {
          label?: string;
          name: string;
        }[]
      | null
    >(null);
    const loadMore = useCallback(async () => {
      const result = await additionalInfoGetter(row);
      setMoreInfo(result);
    }, [row]);

    return (
      <>
        {moreInfo ? (
          <>
            <IconButton icon="Minus" onClick={() => setMoreInfo(null)} />
            {arrayOrArray(moreInfo).map(
              (dataCell: { label?: string; name: string }) => {
                return (
                  <Box key={dataCell.name} ref={ref} as="div">
                    <Box as="strong">{dataCell.name}:</Box> {dataCell.label}
                  </Box>
                );
              },
            )}
          </>
        ) : (
          <IconButton icon="Plus" onClick={() => void loadMore()} />
        )}
      </>
    );
  });

  return InnerRender;
}
